import { render, staticRenderFns } from "./direktur.vue?vue&type=template&id=50eab804&scoped=true&"
import script from "./direktur.vue?vue&type=script&lang=js&"
export * from "./direktur.vue?vue&type=script&lang=js&"
import style0 from "./direktur.vue?vue&type=style&index=0&id=50eab804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eab804",
  null
  
)

export default component.exports